exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.disabled {\r\n    color: gray;\r\n    cursor: not-allowed;\r\n    text-decoration: none;\r\n}\r\n\r\na.iconActive {\r\n    color: green;\r\n}\r\n\r\ndiv.border {\r\n    border-bottom: 10px solid green;\r\n}\r\n\r\ndiv.border.active {\r\n    border-bottom: 10px solid springgreen;\r\n}\r\n\r\n.divs {\r\n    height: 130px;\r\n    margin-bottom: 10px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/siniestros/tracking/tracking-siniestros-o2o.styles.css
// module id = ../../../../../src/app/views/siniestros/tracking/tracking-siniestros-o2o.styles.css
// module chunks = 0